import React from "react";
import { Plane, Hotel, Building2, MapPin } from "lucide-react";
import { PageHero, Reveal, Stagger, StaggerItem, Overline } from "@/components/primitives";
import { CtaStrip } from "@/components/sections";

const CARDS = [
  { icon: Plane, t: "Getting there", d: "30–45 minutes from Chhatrapati Shivaji Maharaj International Airport. Central to Mumbai's Powai, BKC and Andheri business districts. On-site parking available." },
  { icon: Hotel, t: "Where to stay", d: "On-site rooms at Westin Powai Lake, Mumbai, plus a range of nearby hotels across Powai and Andheri. Delegate room rates available on request." },
  { icon: Building2, t: "The city", d: "Mumbai is India's financial and energy capital — an easy, well-connected base for domestic and international delegates." },
];

export default function Venue() {
  return (
    <>
      <PageHero
        overline="Venue & travel"
        title="Westin Powai Lake, Mumbai."
        subtitle="A lakeside venue in Powai, central to Mumbai's business districts and 30–45 minutes from the airport."
        image="/assets/site/venue-westin-powai.jpg"
        imageFallback="https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      />

      <section className="bg-parchment py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Stagger className="grid gap-6 md:grid-cols-3">
            {CARDS.map((c) => (
              <StaggerItem key={c.t}>
                <div className="flex h-full flex-col rounded-3xl border border-border bg-white p-8 shadow-sm">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald2/10 text-emeraldDeep"><c.icon className="h-6 w-6" /></span>
                  <h3 className="mt-5 font-display text-xl font-bold text-navy">{c.t}</h3>
                  <p className="mt-2 text-navy/60">{c.d}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>

          <Reveal className="mt-10">
            <div className="overflow-hidden rounded-3xl border border-border shadow-sm">
              <iframe
                title="Westin Powai Lake, Mumbai"
                src="https://www.google.com/maps?q=The+Westin+Mumbai+Powai+Lake&output=embed"
                className="h-[360px] w-full border-0"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <CtaStrip title="Plan your trip. Reserve your seat." />
    </>
  );
}
